// extracted by mini-css-extract-plugin
export default {"fullscreenAvatar":"Avatar_fullscreenAvatar__Ld24D","fullscreenAvatarImage":"Avatar_fullscreenAvatarImage__mKSNt"};